import React, { useState, useContext, useEffect } from 'react';
import './ProgressTracker.css'; // You can create a separate CSS file for styling
import AuthService from '../../services/AuthService';
import AuthContext from '../../contexts/AuthContext';
import ButtonMinimal from '../buttons/ButtonMinimal';

const ProgressTracker = ({ title, type, id, currentStep, totalSteps }) => {

    const progressPercentage = (currentStep / totalSteps) * 100;
    const progress = progressPercentage + '%';
    const { user } = useContext(AuthContext);

    const [isFollowed, setIsFollowed] = useState(false);

    useEffect(() => {
        if (user) {
            if (type === 'topic') {
                const topicIsFollowed = user.followedTopic.some(topic => Number(topic.topicId) === Number(id));
                setIsFollowed(topicIsFollowed);
            } else {
                const pathIsFollowed = user.followedPath.some(path => Number(path.pathId) === Number(id));
                setIsFollowed(pathIsFollowed);
            }
        }
    }, []);

    const toggleFollow = async (e) => {
        e.preventDefault();

        if (!id) {
            return;
        }

        if (type === 'topic') {
            let topicId = id;
            const endpoint = `/api/userdata/${isFollowed ? 'unfollowTopic' : 'followTopic'}`;
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ topicId: topicId })
            });

            if (response.ok) {
                if (isFollowed) {
                    // Remove the object with the matching pathId from followedPath
                    user.followedTopic = user.followedTopic.filter(topic => topic.topicId !== Number(topicId));
                } else {
                    // Add a new object with pathId to followedPath
                    user.followedTopic = [...user.followedTopic, { topicId, createdAt: new Date() }];
                }
                AuthService.syncLocalUserSession(user);
                setIsFollowed(!isFollowed);
            } else {
                console.error('Failed to update followed path.');
            }
        } else {
            let pathId = id;
            const endpoint = `/api/userdata/${isFollowed ? 'unfollowPath' : 'followPath'}`;
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ pathId: pathId })
            });

            if (response.ok) {
                if (isFollowed) {
                    // Remove the object with the matching pathId from followedPath
                    user.followedPath = user.followedPath.filter(path => path.pathId !== Number(pathId));
                } else {
                    // Add a new object with pathId to followedPath
                    user.followedPath = [...user.followedPath, { pathId, createdAt: new Date() }];
                }
                setIsFollowed(!isFollowed);
                AuthService.syncLocalUserSession(user);
            } else {
                console.error('Failed to update followed path.');
            }
        }
    };

    return (
        <div className="progress-tracker">
            <div className="floatbar-item-title">
                <span style={{ marginRight: '8px' }}>Current Progress</span>
                {user && (
                    <ButtonMinimal value={isFollowed ? (<><span>Unfollow</span></>) : (<><span className="plus-sign">+ </span><span>Follow</span></>)} className={`follow-button ${isFollowed ? 'unfollow-button' : 'follow-button'}`} onClick={toggleFollow} />
                )}
            </div>
            
            <div className="title-and-numbers">
                <div className="title">{title}</div>
                <div className="progress-numbers">{currentStep} / {totalSteps}</div>
            </div>
            <div className="progress-bar">
                <div className="progress-bar-fill" style={{ width: progress }}></div>
            </div>
        </div>
    );
};

export default ProgressTracker;